import type {
  ApiResponse,
  BankTransferEntity,
  CreateBankTransferCommand,
  UpdateBankTransferCommand,
} from "../../../shared/types/api";
import { httpClient } from "../http-client";
import { NEW_API_ENDPOINTS } from "../../../shared/constants/api";
import { Create } from "sharp";

export class CompanyBankTransferApiService {
  async getBankTransfer(
    companyId: number,
  ): Promise<ApiResponse<BankTransferEntity[]>> {
    const response = await httpClient.get<ApiResponse<BankTransferEntity[]>>(
      NEW_API_ENDPOINTS.companyBankTransferController.GET(companyId),
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "회사 무통장 정보를 가져오지 못했습니다.",
      );
    }

    return response.data;
  }

  async createBankTransfer(
    companyId: number,
    request: CreateBankTransferCommand,
  ): Promise<ApiResponse<BankTransferEntity[]>> {
    const response = await httpClient.post<ApiResponse<BankTransferEntity[]>>(
      NEW_API_ENDPOINTS.companyBankTransferController.POST(companyId),
      request,
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "회사 무통장 정보를 생성하지 못했습니다.",
      );
    }

    return response.data;
  }

  async updateBankTransfer(
    companyId: number,
    bankTransferId: number,
    request: UpdateBankTransferCommand,
  ): Promise<ApiResponse<BankTransferEntity>> {
    const response = await httpClient.put<ApiResponse<BankTransferEntity>>(
      NEW_API_ENDPOINTS.companyBankTransferController.PUT(
        companyId,
        bankTransferId,
      ),
      request,
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "회사 무통장 정보를 업데이트하지 못했습니다.",
      );
    }

    return response.data;
  }

  async deleteBankTransfer(
    companyId: number,
    bankTransferId: number,
  ): Promise<ApiResponse<boolean>> {
    const response = await httpClient.delete<ApiResponse<boolean>>(
      NEW_API_ENDPOINTS.companyBankTransferController.DELETE(
        companyId,
        bankTransferId,
      ),
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "회사 무통장 정보를 삭제하지 못했습니다.",
      );
    }

    return response.data;
  }
}

export const companyBankTransferApiService =
  new CompanyBankTransferApiService();
